import $ from 'jquery';

window.$ = $;

const jqVarName = 'jQuery';
window[jqVarName] = $; // can't just assign window.jQuery=$ because webpack ProvidePlugin will process it and will not create a real global variable
